var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTelecounsel = function SvgTelecounsel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "10.0-Telecounselling",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "10.0-Telecounsel-/-Sidebars",
    transform: "translate(-608, -238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "05.Templates/01.Side-bar/Expand/Telecounsel----all-counsels",
    transform: "translate(592, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Body",
    transform: "translate(0, 94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Health-screening",
    transform: "translate(0, 134)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(16, 10)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "chatbubbles",
    mask: "url(#mask-2)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3, 3)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.925838934,11.1828754 C0.925838934,11.1898754 0.925838934,11.2028754 0.917838934,11.2208754 C0.920838934,11.2088754 0.922838934,11.1958754 0.925838934,11.1828754 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7459983,11.6750008 C12.6431158,11.672778 12.5415264,11.65159 12.446332,11.6125003 L10.6720826,10.9834379 L10.6589586,10.9781254 C10.6202669,10.9619956 10.5786959,10.9539147 10.5367797,10.9543754 C10.498143,10.954418 10.4598285,10.961404 10.4236627,10.9750004 C10.3805408,10.9912504 9.99213078,11.1371879 9.58465962,11.2490628 C9.36373776,11.3096878 8.5947297,11.5075003 7.97758589,11.5075003 C6.40019756,11.5075003 4.92530198,10.9012504 3.82506736,9.80031315 C2.73940608,8.7212392 2.13055847,7.25263248 2.13423288,5.72187653 C2.13423288,5.32699746 2.17677085,4.93326655 2.26111558,4.54750179 C2.53578364,3.27812707 3.26323214,2.12343982 4.30940808,1.2975025 C5.38256785,0.455638678 6.70739933,-0.00130031448 8.07132926,0 C9.70277626,0 11.2229811,0.625002643 12.3522762,1.7556274 C13.4197006,2.82656466 14.0046592,4.23468936 14,5.72031403 C13.9990488,6.82424054 13.66944,7.90288791 13.0531641,8.81875086 L13.047227,8.82750086 L13.0241036,8.85875085 C13.0187915,8.86593835 13.0134794,8.87281335 13.0084797,8.88000085 L13.0037926,8.88843834 C12.991367,8.90958081 12.9801011,8.93138388 12.970045,8.95375083 L13.4618851,10.7018755 C13.4836314,10.7739945 13.4954065,10.8487506 13.4968827,10.9240629 C13.4971318,11.1233002 13.4181011,11.3144488 13.2772289,11.455331 C13.1363567,11.5962131 12.9452215,11.6752494 12.7459983,11.6750008 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37037059,12.2934376 C8.30504153,12.1663615 8.18768637,12.0739763 8.04883085,12.0403127 C7.86821864,11.9925002 7.65760855,12.0006252 7.49668244,11.9887502 C5.97720872,11.8830946 4.54734007,11.2309388 3.47134241,10.1528131 C2.51476729,9.20152591 1.8930898,7.96521176 1.69990531,6.63000134 C1.65615841,6.3256264 1.65615841,6.25000142 1.65615841,6.25000142 C1.65611936,6.0420713 1.52740807,5.85586778 1.33291407,5.78237165 C1.13842007,5.70887552 0.918743487,5.7634289 0.781220349,5.91937649 L0.781220349,5.91937649 C0.781220349,5.91937649 0.534987781,6.18750143 0.41874601,6.45656387 C-0.243011487,7.98140226 -0.114554963,9.73390648 0.762471676,11.1459379 C0.843715925,11.2812503 0.843715925,11.3437503 0.825592208,11.4843753 C0.740285747,11.9253127 0.590921321,12.703125 0.513114329,13.1065624 C0.460658048,13.3729642 0.556271613,13.6469164 0.763096632,13.8228123 L0.777470614,13.8349998 C0.911839062,13.941725 1.07834597,13.9998744 1.24993717,14 C1.34645171,14 1.44202936,13.9810716 1.53116726,13.9440622 L3.20323639,13.2987499 C3.2608065,13.2768673 3.32440362,13.2768673 3.38197373,13.2987499 C4.04036462,13.5437498 4.72562861,13.6737498 5.37495764,13.6737498 C6.18400858,13.6745091 6.98326256,13.4967423 7.71572943,13.1531249 C7.88634235,13.0731249 8.15319846,12.98625 8.3094374,12.805625 C8.4302922,12.6624236 8.45425493,12.4609996 8.37037059,12.2934376 Z"
  })))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTelecounsel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/telecounsel.aea38eeb.svg";
export { ForwardRef as ReactComponent };